import type { CSSProperties } from 'react';
import styled from 'styled-components';
import { HStack } from '../Core';

export const DialogContent = styled.div<{
  align?: 'left' | 'right';
  overflow: CSSProperties['overflow'];
  padding?: CSSProperties['padding'];
}>`
  max-height: 100%;
  display: flex;
  flex-direction: column;
  overflow: ${({ overflow }) => overflow};
  padding: ${({ theme, padding }) => padding ?? `${theme.spacing16}px`};
  flex: 1;
  ${({ align }) => align == null && 'text-align: center'};
  ${({ align }) => align === 'left' && 'text-align: left'};
  ${({ align }) => align === 'right' && 'text-align: right'};
`;

export const DialogFooterWrapper = styled(HStack)<{ $showBorder?: boolean }>`
  justify-content: flex-end;
  gap: ${({ theme }) => `${theme.spacing12}px`};
  padding: ${({ theme }) => `${theme.spacing16}px`};
  width: 100%;
  ${({ $showBorder = true, theme }) => $showBorder && `border-top: 1px solid ${theme.backgroundDivider};`}
`;
